import { render } from "./coupon.vue?vue&type=template&id=8552bf5a&scoped=true&ts=true"
import script from "./coupon.vue?vue&type=script&lang=ts"
export * from "./coupon.vue?vue&type=script&lang=ts"

import "./coupon.vue?vue&type=style&index=0&id=8552bf5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8552bf5a"]])

export default __exports__